module.exports = __webpack_public_path__ + "images/bug_wine_red_size_4_68caf62e859f242035b4366f59786b66.png";